import styled, { css } from 'styled-components';
import { isDiferentiatedBrands } from '../../../themes/themes';
import { getBrandStorage } from '../../../utils/getBrand';

const brand = getBrandStorage();

export const Wrapper = styled.div`
  font-family: 'Poppins' !important;

  ${({ theme }) => css`
    height: auto;
    font-family: 'Poppins' !important;

    .filter-group {
      display: flex;
      flex-direction: column;
    }

    .outlined-input-iconed {
      background-color: ${isDiferentiatedBrands(brand)
        ? theme.palette.secondary.white
        : '#FFF'};
      border-radius: 20px;
      height: 40px;
    }

    /* checkbox marcado no azul do Figma (#1392EC), nao no coral do tema */
    .MuiCheckbox-root.Mui-checked {
      color: #1392ec !important;
    }
    .MuiButton-textPrimary {
      color: #1392ec;
    }

    /* slider Preco por pessoa: trilho mais grosso (#E2E8F0) + preenchido azul */
    .MuiSlider-root {
      color: #1392ec;
      padding: 8px 0;
    }
    .MuiSlider-rail {
      background-color: #e2e8f0;
      height: 6px;
      border-radius: 8px;
      opacity: 1;
    }
    .MuiSlider-track {
      height: 6px;
      border-radius: 8px;
    }
    .MuiSlider-thumb {
      background-color: #1392ec;
      width: 16px;
      height: 16px;
      margin-top: -5px;
    }
  `}
`;

export const FilterHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e6e6e6;
  padding-bottom: 8px;
`;

export const FilterMainTitle = styled.span`
  font-weight: 700;
  font-size: 18px;
`;

export const FilterTitle = styled.span`
  margin-top: 24px;
  margin-bottom: 12px;
  font-weight: 700;
  font-size: 14px;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  color: #64748b;
`;

export const ThinText = styled.div`
  ${({ theme }) => css`
    font-family: 'Poppins';
    font-size: 13px;
    font-weight: 200;
  `}
`;

/* valores min/max ABAIXO do slider (Figma): 12px, 700, #64748B */
export const PriceRange = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
  font-size: 12px;
  font-weight: 700;
  color: #64748b;
`;
